import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import { MarketmanagerAdminModule } from '../../admin/admin.module';
import {
    MarketdateExpenseService,
    MarketdateExpensePopupService,
    MarketdateExpenseComponent,
    MarketdateExpenseDetailComponent,
    MarketdateExpenseDialogComponent,
    MarketdateExpensePopupComponent,
    MarketdateExpenseDeletePopupComponent,
    MarketdateExpenseDeleteDialogComponent,
    marketdateExpenseRoute,
    marketdateExpensePopupRoute,
} from './';

const ENTITY_STATES = [
    ...marketdateExpenseRoute,
    ...marketdateExpensePopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        MarketmanagerAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdateExpenseComponent,
        MarketdateExpenseDetailComponent,
        MarketdateExpenseDialogComponent,
        MarketdateExpenseDeleteDialogComponent,
        MarketdateExpensePopupComponent,
        MarketdateExpenseDeletePopupComponent,
    ],
    entryComponents: [
        MarketdateExpenseComponent,
        MarketdateExpenseDialogComponent,
        MarketdateExpensePopupComponent,
        MarketdateExpenseDeleteDialogComponent,
        MarketdateExpenseDeletePopupComponent,
    ],
    providers: [
        MarketdateExpenseService,
        MarketdateExpensePopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdateExpenseModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense.module.ts